import { useTranslation } from 'react-i18next';
import { ColumnConfig } from '../../../../components/DatasetTable';
import { ConvertedBayFeature } from '../converter.serializable.model';

function useLayoutDataTableConfig(): ColumnConfig<ConvertedBayFeature>[] {
  const { t } = useTranslation('designer');
  const columnsConfig: ColumnConfig<ConvertedBayFeature>[] = [
    {
      field: 'baySourceIndex',
      title: t`Bay Index`,
      hasFilter: true,
    },
    {
      field: 'title',
      title: t`Bay`,
      hasFilter: true,
    },
    {
      field: 'areaId',
      title: t`Area`,
      hasFilter: true,
    },
    {
      field: 'type',
      title: t`Type`,
      hasFilter: true,
    },
    {
      field: 'details.locationOrder',
      title: t`Location Sequence`,
      hasFilter: true,
    },
    {
      field: 'details.bayType',
      title: t`Bay Type`,
      hasFilter: true,
    },
    {
      field: 'details.width',
      title: t`Width`,
      hasFilter: true,
    },
    {
      field: 'details.height',
      title: t`Height`,
      hasFilter: true,
    },
    {
      field: 'details.depth',
      title: t`Depth`,
      hasFilter: true,
    },
    {
      field: 'id',
      title: t`ID`,
      hasFilter: true,
    },
    {
      field: 'shelvingType',
      title: t`Shelving Type`,
      hasFilter: true,
    },
  ];

  return columnsConfig;
}
export default useLayoutDataTableConfig;
